import React from 'react'
import ColorPill from 'core-system/Pill/ColorPill'
import styled from 'styled-components'

export interface ProgramAmountItem {
  programId?: string
  programDisplayName: string
}

const PROGRAM_PILL_COLORS: Array<
  'green' | 'red' | 'blue' | 'yellow' | 'gray' | 'purple' | 'pink'
> = ['purple', 'pink', 'blue', 'green', 'yellow', 'gray', 'red']

const PillRow = styled.div<{ marginTop?: string }>`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: ${(p) => p.marginTop ?? '0.5rem'};
`

interface ProgramPillsProps {
  programAmounts: ProgramAmountItem[] | undefined
  /** Set to 0 or '0' to align with table cells that don't need top margin */
  marginTop?: string | number
}

function ProgramPills({ programAmounts, marginTop }: ProgramPillsProps) {
  if (!programAmounts?.length) return <>—</>
  return (
    <PillRow marginTop={marginTop === 0 || marginTop === '0' ? '0' : undefined}>
      {programAmounts.map((pa, i) => (
        <ColorPill
          key={pa.programId ? `${pa.programId}-${i}` : i}
          color={PROGRAM_PILL_COLORS[i % PROGRAM_PILL_COLORS.length]}
          text={pa.programDisplayName}
        />
      ))}
    </PillRow>
  )
}

export default React.memo(ProgramPills)
